<template>
  <div id="login-google"></div>
</template>

<script>
import { headersLogin } from "../../mixins/HeadersMixin";
import { enviar } from "../../mixins/RequisicaoMixin";

export default {
  mounted() {
    const vm = this;
    function logarComGoogle(respostaGoogle) {
      gerenciarCarregamentoLogin(true);
      const token = respostaGoogle.credential;
      const cabecalho = headersLogin();
      enviar("/api/v1/auth/social", cabecalho, {
        token,
      })
        .then((s) => {
          const novoUsuarioLogado = montrarDadosUsuarioLogado(s);
          localStorage.setItem(
            "usuarioLogado",
            JSON.stringify(novoUsuarioLogado)
          );
          vm.$emit("redirecionarUsuario", novoUsuarioLogado);
        })
        .catch(() => {
          vm.$store.commit(
            "erro",
            "Sua conta do Google não existe em nossa base de dados."
          );
        })
        .finally(() => {
          gerenciarCarregamentoLogin(false);
        });
    }
    function montrarDadosUsuarioLogado(dadosUsuarioLogado) {
      var usuarioLogado = Object.assign({}, dadosUsuarioLogado);
      usuarioLogado.logadoGoogle = true;
      delete usuarioLogado.tipo;
      return usuarioLogado;
    }

    function configurarBotaoGoogle() {
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_ID_CLIENTE_LOGIN_GOOGLE,
        callback: logarComGoogle,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("login-google"),
        {
          theme: "filled_blue",
          size: "medium",
          type: "icon",
          text: "sign_in_with",
        }
      );
    }
    function gerenciarCarregamentoLogin(status) {
      vm.$emit("gerenciarCarregamentoLoginGoogle", status);
    }
    localStorage.clear();
    window.onGoogleLibraryLoad = () => {
      configurarBotaoGoogle();
    };
    // É necessário chamar essa segunda vez, pois ao deslogar e voltar a tela de login
    // o navegador não entende que a tela foi 'recarregada' e não configura o botão
    // por conta do 'onGoogleLibraryLoad' que funciona como o evento 'onload'
    configurarBotaoGoogle();
  },
};
</script>

<style>
</style>